<template>
  <hm-card-inner :id="$attrs['id']" :title="title">
    <slot />
    <hm-input v-model="filter"
              :lazy="false"
              :label="$t('util.hmFilter.filter')"
              name="filter"
              cols="12 2@hd start-11@hd 3@desktop start-10@desktop 6@tablet start-7@tablet">
      <template slot="icon-inline-left" slot-scope="slot">
        <icon icon="filter" />
      </template>
      <template slot="icon-inline-right" slot-scope="slot">
        <input-icon-button v-if="!isEmpty(filter)" :border="false" icon="close-text" @click="filter = null" />
      </template>
    </hm-input>
  </hm-card-inner>
</template>

<script>

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import { clone, isNil, isEmpty, startsWith, lowerCase, toString } from 'lodash';

export default {
  name: 'HmFilter',

  mixins: [HotelmeisterMixin],
  props: {
    title: {
      required: false,
      type: String,
      default: null,
    },
    rows: {
      required: true,
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      filter: null,
    };
  },

  watch: {
    filter: function () {
      this.updateFilteredRows();
    },
    rows: {
      handler: function () {
        this.updateFilteredRows();
      },
      deep: true,
    },
  },

  methods: {
    updateFilteredRows() {
      let ret = null;
      if (isEmpty(this.filter)) {
        ret = this.rows;
      } else {
        ret = this.rows.filter(it => Object.values(it).map(str => toString(str)).filter(str => !isEmpty(str) && lowerCase(str).indexOf(lowerCase(this.filter)) >= 0).length > 0);
      }

      this.$emit('filter', ret);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '~styles/import';

  .hm-icon {
    display: grid;
  }


  .payment-status {
    &__notification {
      color: $error;
      font-size: 1.1rem;
    }
  }

  .chart__wrapper__wrapper {
    position: relative;
    height: 0;
    padding-bottom: 100%;
    overflow: hidden;

    .chart__wrapper {
      position: relative;
      top: 0;
      margin-top: calc((100% - 200px) / 2);
    }
    .chart__info {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      text-align:center;
    }
    .chart__percent {
      font-size: 3rem;
      font-weight:bold;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/lib/util/HmFilter.vue